import { Card, CardContent, Chip, Grid } from '@material-ui/core';
import * as React from 'react';
import { injectIntl } from 'react-intl';

import * as models from '@app/models/index';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { SharedService } from '@app/services/shared.service';
import { withAxiosCancellation } from '../../core/axios-cancel.component';

import { SnackBarVariants } from '@app/app.enum';
import withSnackBar from '@app/components/core/message.component';
import Axios from 'axios';

const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);

class AdminDashboardComponent extends React.Component<models.IDashboardComponentProps, models.IDashboardState> {
	constructor(props: models.IDashboardComponentProps) {
		super(props);
		this.getAccountDetail();
		this.state = models.initialDashboardState();
	}

	public render() {
		let name = '';
		if (this.state.user) {
			const { firstName, lastName, account } = this.state.user;
			if (firstName && firstName === lastName) {
				name = firstName;
			} else if (firstName && firstName !== lastName) {
				name = firstName + ' ' + lastName;
			} else {
				name = account.name;
			}
		}

		return (
			<div>
				<Grid container={true} spacing={2}>
					<Grid item={true} xs={12} sm={12} md={12} lg={12}>
						<Card>
							<CardContent>
								<Grid container={true} alignItems='center' spacing={2}>
									<Grid item={true} lg={7} md={12} sm={12} xs={12}>
										<Grid container={true} justifyContent='center'>
											<Grid item={true} lg={11}>
												<span className='pr-1'>
													{this.props.intl.formatMessage({
														id: 'app.dashboard-welcome',
													})}
												</span>
												<span className='primary-color pr-1'>{name}</span>
												<Chip
													color='secondary'
													label={this.props.intl.formatMessage({
														id: 'app.user.role-' + this.state.user.role,
													})}
												/>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</div>
		);
	}

	// Get account details
	private async getAccountDetail() {
		try {
			const result: models.IUser = await accountService.getOwnUserRecord(this.props.axiosCancellationToken);
			this.setState({
				user: result,
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				this.props.openSnackBar(sharedService.parseError(error), SnackBarVariants.Error);
			}
		}
	}
}
export default withAxiosCancellation(withSnackBar(injectIntl(AdminDashboardComponent)));



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/admin-dashboard.component.tsx